module.exports = __webpack_public_path__ + "static/img/one_underwriting_logo.a1143d31.png";